
const IntToHex = (colour) => {

    return (
        colour.toString(16).padStart(6, '0')
    )
}

export default IntToHex